import type { ReactNode } from 'react';

export const symbol_crop_16_9: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-280q-24 0-42-18t-18-42v-280q0-24 18-42t42-18h600q24 0 42 18t18 42v280q0 24-18 42t-42 18H180Zm0-60h600v-280H180v280Zm0 0v-280 280Z"
		/>
	</svg>
);
